/* ============================================================
   Quick-buy size buttons on product cards.

   Bound by delegation on document, deliberately. The previous version
   lived in an inline <script> inside variant-quickbuy.liquid and attached
   a listener to every matching form on DOMContentLoaded. That works only
   for markup present in the initial HTML.

   The product page recommendations are fetched after load and injected by
   <product-recommendations> with innerHTML. Scripts inserted that way
   never execute, and DOMContentLoaded has already fired, so those forms
   ended up with no handler at all: the browser submitted them natively to
   /cart/add and Shopify redirected to the cart page.

   Delegation on document has no such timing problem - a form works the
   moment it exists, whenever that is, with no re-initialisation step and
   nothing to remember to call after an injection.

   Scoped to forms inside .size-variant-buttons so it cannot collide with
   Dawn's own product form, which carries the same data-type but is
   handled by product-form.js.
   ============================================================ */

(function () {
  'use strict';

  var SCOPE = '.size-variant-buttons';
  var ERROR_TIMEOUT = 5000;
  var SECTIONS = 'cart-notification-product,cart-notification-button,cart-icon-bubble';

  function parts(form) {
    var wrapper = form.closest(SCOPE);
    var errorWrapper = wrapper ? wrapper.querySelector('.product-form__error-message-wrapper') : null;
    return {
      button: form.querySelector('button[type="submit"]'),
      errorWrapper: errorWrapper,
      errorMessage: errorWrapper ? errorWrapper.querySelector('.product-form__error-message') : null,
    };
  }

  function showError(p, message) {
    if (!p.errorWrapper || !p.errorMessage) return;
    p.errorMessage.textContent = message || 'An error occurred. Please try again.';
    p.errorWrapper.hidden = false;
    setTimeout(function () {
      p.errorWrapper.hidden = true;
      p.errorMessage.textContent = '';
    }, ERROR_TIMEOUT);
  }

  function setLoading(p, loading) {
    if (!p.button) return;
    var spinner = p.button.querySelector('.variant-button__loading-spinner');
    var text = p.button.querySelector('.variant-button__text');
    var soldOut = p.button.querySelector('.sold-out-message');

    if (loading) {
      // aria-disabled, not disabled: the disabled attribute is what marks a
      // variant as genuinely out of stock, and the tooltip keys off it.
      p.button.setAttribute('aria-disabled', 'true');
    } else {
      p.button.removeAttribute('aria-disabled');
    }
    if (spinner) spinner.classList.toggle('hidden', !loading);
    if (text) text.classList.toggle('hidden', loading);
    if (soldOut && loading) soldOut.classList.add('hidden');
  }

  // Fallback when the cart notification cannot be rendered: keep the header
  // bubble honest so the shopper still sees the item landed.
  function refreshCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=cart-icon-bubble')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('#cart-icon-bubble');
        if (next) bubble.innerHTML = next.innerHTML;
      })
      .catch(function () {
        /* the add still succeeded; leave the bubble alone */
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.nodeName !== 'FORM') return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (!form.closest || !form.closest(SCOPE)) return;

      event.preventDefault();
      event.stopPropagation();

      var p = parts(form);
      if (!p.button || p.button.hasAttribute('disabled')) return;
      if (p.button.getAttribute('aria-disabled') === 'true') return;

      if (p.errorWrapper) p.errorWrapper.hidden = true;
      if (p.errorMessage) p.errorMessage.textContent = '';
      setLoading(p, true);

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      var body = new FormData(form);

      // The snippet bakes sections_url in as {{ request.path }}. That is
      // correct on a collection page, but recommendations are rendered by
      // the recommendations endpoint, so the value ends up as
      // /recommendations/products - not a URL Shopify can render sections
      // against. It returns no sections, and cart-notification.js then
      // reads parsedState.sections['cart-notification-product'] off null.
      //
      // Set it from the page the shopper is actually on instead, which is
      // right wherever the card came from.
      body.set('sections', SECTIONS);
      body.set('sections_url', window.location.pathname);

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: body,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            showError(p, response.description);
            return;
          }
          var cartNotification = document.querySelector('cart-notification');

          // renderContents indexes into response.sections without checking
          // it exists. If the sections render ever fails again, refresh the
          // cart count and stay put rather than throwing - the item is
          // already in the cart by this point, so the add succeeded.
          if (cartNotification && response.sections) {
            cartNotification.setActiveElement(document.activeElement);
            cartNotification.renderContents(response);
          } else {
            refreshCartCount();
          }
        })
        .catch(function (error) {
          console.error('Quick buy failed:', error);
          showError(p, error.message);
        })
        .finally(function () {
          setLoading(p, false);
        });
    },
    // Capture phase: runs before any handler bound on the form itself, so a
    // stray listener left elsewhere cannot fire a second add.
    true
  );

  // Tooltip on genuinely out-of-stock buttons. Delegated for the same
  // reason as above - injected cards need it too.
  document.addEventListener(
    'mouseover',
    function (event) {
      var button = event.target.closest && event.target.closest('.variant-button');
      if (!button || !button.closest(SCOPE)) return;
      if (button.hasAttribute('disabled')) button.setAttribute('data-showing-tooltip', 'true');
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      var button = event.target.closest && event.target.closest('.variant-button');
      if (button) button.removeAttribute('data-showing-tooltip');
    },
    true
  );
})();